import { isNil } from 'lodash'

export const hasTag = (value: string | string[]) => {
  if (Array.isArray(value)) {
    return value.length > 0
  }
  if (value === '') {
    return false
  }
  return !isNil(value)
}
